import React from "react";
import { AboutTemplate } from "@templates/about-us";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { useTranslation } from "next-i18next";

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "en", ["common", "about"])),
    },
  };
};

export default function About() {
  const { t } = useTranslation("about");

  return (
    <>
      <Head>
        <title>{t("title")} - FeelingHome</title>
      </Head>
      <AboutTemplate />;
    </>
  );
}
